<template>
<span v-if="!alt"
      ref="icon"
      :class="`odr-icon odr-icon_size-${size} ${halfWidth === 'true' ? 'odr-icon_half-width-' + size : ''} odr-icon_fill-${color}`">
</span>
<tooltip v-else>
    <span ref="icon"
          slot="trigger"
          :class="`odr-icon odr-icon_size-${size} ${halfWidth === 'true' ? 'odr-icon_half-width-' + size : ''} odr-icon_fill-${color}`">
    </span>
    <span slot="content">{{ alt }}</span>
</tooltip>
</template>

<script>
import '../styles/icon.scss'
import tooltip from './tooltip.vue'
import { coloringMixin } from '../mixins/coloring'

let cachedIcons = {}

export default {
    mixins: [coloringMixin],
    props: {
        alt: {
            type: String,
            _descr: 'Hint shown on mouse over',
        },
        size: {
            type: String,
            default: 'm',
            validator: v => (v === 'l' || v === 'm' || v === 's' || v === 'xs'),
            _descr: 'size: l|m|s|xs',
        },
        halfWidth: {
            type: String,
            default: 'false',
            _descr: 'Set width of icon to half',
        },
    },
    data () {
        return {
            svg: '',
        }
    },
    mounted () {
        if (window.__odrDisableIconsFetch || !this.icon) {
            return
        }
        if (cachedIcons[this.icon]) {
            this.placeIcon()
            return
        }

        var xhr = new XMLHttpRequest()
        xhr.open('GET', `${this.$root.appConfig.staticUrl}/material-design-icons/ic_${this.icon}_24px.svg`)
        xhr.send()
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4 && xhr.status === 200) {
                let svg = new DOMParser().parseFromString(xhr.responseText.replace('<svg', '<svg class="odr-icon__svg" style="fill: inherit !important;"'), 'image/svg+xml')
                if (svg.querySelector('svg')) {
                    cachedIcons[this.icon] = new XMLSerializer().serializeToString(svg)
                    this.placeIcon()
                }
            }
        }
    },
    methods: {
        placeIcon () {
            if (this.$refs && this.$refs.icon) {
                this.$refs.icon.innerHTML = cachedIcons[this.icon]
            }
        },
    },
    computed: {
        icon () {
            let iconMapping = {
                newappointment: 'add_box',
                manage: 'create',
                information: 'info_outline',
                clock: 'query_builder',
            }

            return iconMapping[this.$slots.default[0].text.trim()] || this.$slots.default[0].text.trim()
        },
    },
    components: {
        tooltip,
    },
}
</script>
